import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretDown } from '@redteclab/icons'

import { Button } from 'base-ui'

import { HOW_BONUS_CALCULATED_ANCHOR } from '../HowBonusIsCalculated/HowBonusIsCalculated'
import { RX_HOW_TO_REDEEM_ANCHOR } from '../HowToRedeem/RxLpComHowToRedeem'

export const RxLpComHeroDescription: FC = () => (
  <div className="flex w-full flex-1 flex-col gap-4 tablet:justify-center">
    <h1 className="text-center text-2xl font-medium leading-2xl text-dark-primary-max tablet:text-left tablet:text-4xl tablet:leading-4xl">
      <FormattedMessage id="rx.com.hero.title" />
    </h1>
    <div className="mb-2 text-center text-s leading-s text-dark-primary-max tablet:mb-0 tablet:text-left">
      <FormattedMessage id="rx.com.hero.description" />
    </div>
    <div className="flex flex-col gap-2 tablet:flex-row tablet:gap-4">
      <Button<'a'>
        className="whitespace-normal tablet:min-h-14 tablet:text-m"
        data-qa-id="rx.com.hero.cta.private.erx"
        href={`#${RX_HOW_TO_REDEEM_ANCHOR}`}
        size="large"
        slots={{ root: 'a' }}
        startIcon={<IconCaretDown />}
      >
        <FormattedMessage id="rx.com.hero.cta.private.erx" />
      </Button>
      <Button<'a'>
        className="whitespace-normal tablet:min-h-14 tablet:text-m"
        color="secondary"
        data-qa-id="rx.com.hero.cta.bonus"
        href={`#${HOW_BONUS_CALCULATED_ANCHOR}`}
        size="large"
        slots={{ root: 'a' }}
        startIcon={<IconCaretDown />}
      >
        <FormattedMessage id="rx.com.hero.cta.bonus" />
      </Button>
    </div>
  </div>
)
